module.exports = __webpack_public_path__ + "img/demo2-poster.644e2cca.jpg";